export var ResponseState;
(function (ResponseState) {
    ResponseState["COMPLETE"] = "COMPLETE";
    ResponseState["DRAFT"] = "DRAFT";
    ResponseState["REJECTED"] = "REJECTED";
    ResponseState["SKIP"] = "SKIP";
    ResponseState["PENDING"] = "PENDING";
})(ResponseState || (ResponseState = {}));
